import { createContext, useContext, useEffect, useState, useCallback } from "react";

const EN = {
  // Nav & layout
  "Panel": "Dashboard", "Abonelikler": "Subscriptions", "Alınan Çekler": "Received Checks",
  "Bankaya Verilen Çekler": "Checks Given to Bank", "Cirolanan Çekler": "Endorsed Checks",
  "Kendi Çeklerimiz": "Our Own Checks", "Diğer Ödemeler": "Other Payments",
  "Diğer Tahsilatlar": "Other Collections", "Kasa": "Cash Register",
  "Kredi Kartları": "Credit Cards", "POS Hareketleri": "POS Transactions",
  "Kullanıcılar": "Users", "Ayarlar": "Settings", "Firmalar": "Companies", "Yedekleme": "Backup",
  "Abonelik yakında": "Subscription coming soon",
  "Iyzico ile aylık/yıllık planlar çok yakında.": "Monthly/yearly plans with Iyzico coming soon.",
  "Çıkış yap": "Sign out", "Süper Admin": "Super Admin", "Admin": "Admin",
  "Yazabilir": "Editor", "İzleyici": "Viewer",
  // Enum labels
  "Aktif": "Active", "Pasif": "Inactive", "İptal": "Cancelled", "Haftalık": "Weekly",
  "Aylık": "Monthly", "3 Aylık": "Quarterly", "Yıllık": "Yearly", "Portföyde": "In Portfolio",
  "Bankaya Verildi": "Given to Bank", "Ciro Edildi": "Endorsed", "Tahsil Edildi": "Collected",
  "İade": "Returned", "Bankada": "At Bank", "Ödendi": "Paid", "Karşılıksız": "Bounced",
  "Verildi": "Issued", "Bekliyor": "Pending", "Gecikti": "Overdue", "Nakit": "Cash",
  "Havale/EFT": "Wire/EFT", "Kredi Kartı": "Credit Card", "Planlandı": "Planned",
  "Hesaba Geçti": "Settled", "Ödenecek": "Due", "Kapalı": "Closed",
  "Tahsil Edilecek": "To Collect", "Giriş": "Income", "Çıkış": "Expense",
  "Müşteri": "Customer", "Tedarikçi": "Supplier", "Diğer": "Other",
  // Module subtitles
  "Tekrarlayan abonelik ve üyelik ödemeleriniz": "Your recurring subscription and membership payments",
  "Müşterilerden aldığınız çekler": "Checks received from customers",
  "Tahsil için bankaya verdiğiniz çekler": "Checks given to the bank for collection",
  "Başkasına ciro ettiğiniz çekler": "Checks you endorsed to others",
  "Kendi keşide ettiğiniz çekler": "Checks issued by your company",
  "Doğrudan borçlandırma sistemi kayıtları": "Direct debit system records",
  "Kira, elektrik, muhasebeci vb. sabit giderleriniz": "Rent, utilities, accountant and other fixed expenses",
  "Kira, komisyon, hizmet vb. gelen tahsilatlarınız": "Rent, commission, service and other incoming collections",
  "Nakit giriş/çıkış hareketleri": "Cash income/expense transactions",
  "Kart limitleri, ekstre ve son ödeme takibi": "Card limits, statements and due date tracking",
  "Günsonu tutar, komisyon oranı, hesabınıza geçecek net tutar": "Day-end total, commission rate and net amount to be settled",
  // Columns & fields
  "Çek No": "Check No", "Banka": "Bank", "Kimden Alındı": "Received From",
  "Kime Verildi": "Issued To", "Kime Ciro Edildi": "Endorsed To", "Şirket": "Company",
  "Tutar": "Amount", "Tutar (₺)": "Amount (₺)", "Vade": "Due Date", "Vade Tarihi": "Due Date",
  "Durum": "Status", "Keşide Tarihi": "Issue Date", "Notlar": "Notes",
  "Abonelik": "Subscription", "Abonelik Adı": "Subscription Name", "Firma": "Company",
  "Firma / Sağlayıcı": "Company / Provider", "Sıklık": "Frequency", "Başlangıç": "Start",
  "Başlangıç Tarihi": "Start Date", "Sonraki Ödeme": "Next Payment",
  "Sonraki Ödeme Tarihi": "Next Payment Date", "Borçlu Firma": "Debtor Company",
  "Tarih": "Date", "Firma / Alıcı": "Company / Payee", "Firma / Ödeyen": "Company / Payer",
  "Ödeme Şekli": "Payment Method", "Açıklama": "Description", "Tür": "Type",
  "Kart": "Card", "Kart Adı": "Card Name", "Son 4": "Last 4", "Son 4 Hane": "Last 4 Digits",
  "Limit": "Limit", "Kart Limiti (₺)": "Card Limit (₺)", "Ekstre": "Statement",
  "Ekstre Tutarı (₺)": "Statement Amount (₺)", "Kesim Tarihi": "Statement Cut Date",
  "Son Ödeme": "Due Date", "Son Ödeme Tarihi": "Payment Due Date",
  "POS Terminal": "POS Terminal", "Brüt Tutar": "Gross Amount",
  "Brüt Tutar (Günsonu) (₺)": "Gross Amount (Day-end) (₺)", "Komisyon": "Commission",
  "Komisyon Oranı (%)": "Commission Rate (%)", "Net Tutar": "Net Amount",
  "Terminal": "Terminal", "Terminal Adı": "Terminal Name",
  "Şirket (boş bırakılırsa terminalden alınır)": "Company (taken from terminal if empty)",
  // Stat cards
  "Toplam Kayıt": "Total Records", "Toplam İşlem": "Total Transactions",
  "Aktif Abonelik (₺)": "Active Subscriptions (₺)", "Bekleyen (₺)": "Pending (₺)",
  "Tahsil Edilen (₺)": "Collected (₺)", "Bankada (₺)": "At Bank (₺)",
  "Ciro Edildi (₺)": "Endorsed (₺)", "Ödenen (₺)": "Paid (₺)", "Verildi (₺)": "Issued (₺)",
  "Ödenecek (₺)": "Due (₺)", "Tahsil Edilecek (₺)": "To Collect (₺)",
  "Giriş (₺)": "Income (₺)", "Çıkış (₺)": "Expense (₺)", "Bakiye (₺)": "Balance (₺)",
  "Genel Toplam (₺)": "Grand Total (₺)", "Brüt Toplam (₺)": "Gross Total (₺)",
  "Komisyon (₺)": "Commission (₺)", "Hesabınıza Geçen Net (₺)": "Net Settled (₺)",
  "Ödenecek Ekstre (₺)": "Statement Due (₺)", "Ödenen Ekstre (₺)": "Statement Paid (₺)",
  "adet": "items",
  // Buttons & common
  "Yenile": "Refresh", "İçe Aktar": "Import", "Dışa Aktar": "Export",
  "Tümünü Sil": "Delete All", "Kaydet": "Save", "Vazgeç": "Cancel", "Sil": "Delete",
  "Kapat": "Close", "Oluştur": "Create", "Aktar": "Import", "Şablon İndir": "Download Template",
  "CSV olarak indir": "Download as CSV", "PDF olarak indir": "Download as PDF",
  "Seçilenleri Sil": "Delete Selected", "Yeni Terminal": "New Terminal",
  "Yeni Kullanıcı": "New User", "Yeni": "New", "Düzenle": "Edit",
  "Tüm Şirketler": "All Companies", "Tüm Durumlar": "All Statuses",
  "Tüm Ödeme Şekilleri": "All Payment Methods", "İşlem": "Actions",
  "kayıt seçildi": "records selected", "Henüz kayıt yok.": "No records yet.",
  "Hareketler": "Transactions", "Aylık Özet": "Monthly Summary", "POS'lar": "POS Terminals",
  "Ay": "Month", "Brüt": "Gross", "Net": "Net", "Komisyon %": "Commission %",
  "Henüz hareket yok.": "No transactions yet.",
  "Henüz terminal yok. Terminal eklediğinizde komisyon oranı hareket formunda otomatik gelir.": "No terminals yet. Commission rate auto-fills once you add one.",
  "Silmek istediğinize emin misiniz?": "Are you sure you want to delete?",
  "Bu işlem geri alınamaz.": "This action cannot be undone.",
  "Bu kayıt kalıcı olarak silinecek.": "This record will be permanently deleted.",
  "Bu modüldeki TÜM kayıtlar kalıcı olarak silinecek.": "ALL records in this module will be permanently deleted.",
  "kayıt kalıcı olarak silinecek.": "records will be permanently deleted.",
  "CSV ile İçe Aktar": "Import via CSV",
  "Şablonu indirin, doldurun ve yükleyin. Sütun başlıkları değiştirilmemelidir.": "Download the template, fill it in and upload. Column headers must not be changed.",
  "CSV Dosyası": "CSV File", "kayıt aktarıldı": "records imported",
  "Terminal seçin": "Select terminal", "Seçiniz": "Select",
  "Terminali silmek istediğinize emin misiniz?": "Are you sure you want to delete the terminal?",
  "Günsonu (brüt) tutar ve komisyon oranını girin — net tutar otomatik hesaplanır.": "Enter day-end (gross) amount and commission rate — net is calculated automatically.",
  "Komisyon Tutarı:": "Commission Amount:", "Hesabınıza Geçen (Net):": "Net to Your Account:",
  "kayıt": "records",
  // Auth pages
  "Giriş Yap": "Sign In", "Firma hesabınıza erişmek için giriş yapın.": "Sign in to access your company account.",
  "E-posta": "Email", "Şifre": "Password",
  "Tüm firmalarınızın finansı,": "All your companies' finances,", "tek platformda.": "in one platform.",
  "© 2026 TEMHA — Çok firmalı finans yönetim platformu": "© 2026 TEMHA — Multi-company finance management platform",
  "Firmanızı TEMHA'ya taşımak mı istiyorsunuz?": "Want to move your company to TEMHA?",
  "Firma kaydı oluşturun": "Create a company account", "Firma Kaydı": "Company Registration",
  "Yeni firma oluşturun. Kayıt sonrası e-posta doğrulaması gereklidir.": "Create a new company. Email verification is required after registration.",
  "Firma Adı": "Company Name", "Vergi No": "Tax Number", "Telefon": "Phone",
  "Admin E-posta": "Admin Email", "Şifre (Tekrar)": "Password (Repeat)",
  "Firmayı Oluştur": "Create Company", "Zaten hesabınız var mı?": "Already have an account?",
  "Giriş yapın": "Sign in", "Kaydınız alındı": "Registration received",
  "Giriş sayfasına dön": "Back to sign in", "Onay beklemeden anında aktif": "Instantly active, no approval wait",
  "Verileriniz diğer firmalardan tamamen izole": "Your data is fully isolated from other companies",
  "Çift taraflı muhasebeye uygun hazır hesap planı": "Ready chart of accounts for double-entry bookkeeping",
  "Abonelik yakında — Iyzico ile aylık/yıllık planlar geliyor.": "Subscriptions coming soon — monthly/yearly plans with Iyzico.",
  "Firmanızı dakikalar içinde": "Move your company", "TEMHA'ya taşıyın.": "to TEMHA in minutes.",
  "E-postanız doğrulanmadı.": "Your email is not verified.",
  "Yeni doğrulama bağlantısı isteyin": "Request a new verification link",
  "Doğrulama tamamlandı": "Verification complete", "Doğrulama başarısız": "Verification failed",
  "Doğrulama bağlantısı gönder": "Send verification link",
  "E-posta adresinizi girin, size yeni bir doğrulama bağlantısı gönderelim.": "Enter your email and we'll send you a new verification link.",
  "Bağlantıyı Gönder": "Send Link",
  "Bağlantı gönderildi. E-posta kutunuzu (ve spam klasörünü) kontrol edin.": "Link sent. Check your inbox (and spam folder).",
  "E-postanız doğrulanıyor...": "Verifying your email...",
  // Dashboard
  "Firmanızın finansal görünümüne hoş geldiniz.": "Welcome to your company's financial overview.",
  "Kullanıcı": "Users", "Hesap Planı": "Chart of Accounts", "hesap": "accounts",
  "Modül Özeti": "Module Summary", "Nakit Akışı Özeti": "Cash Flow Summary",
  "Örnek veri — modüller yakında": "Sample data — modules coming soon",
  "Güvenliğiniz için ilk girişte şifrenizi değiştirmeniz önerilir.": "For your security, we recommend changing your password on first login.",
  "Şifremi Değiştir": "Change My Password", "Süper Admin Paneli": "Super Admin Panel",
  "TEMHA platformundaki tüm firmaları yönetin.": "Manage all companies on the TEMHA platform.",
  "Tenant firmaları görüntüleyin, aktif/pasif durumlarını yönetin.": "View tenant companies, manage active/inactive status.",
  "Profil Ayarları": "Profile Settings", "E-posta ve şifrenizi güncelleyin.": "Update your email and password.",
  "Deneme": "Trial",
  // Users page
  "Firmanızdaki kullanıcıları ve rollerini yönetin.": "Manage users and roles in your company.",
  "Ad Soyad": "Full Name", "Rol": "Role", "Admin — tam yetki": "Admin — full access",
  "Yazabilir — kayıt ekler/düzenler": "Editor — can add/edit records",
  "İzleyici — sadece görür": "Viewer — read only",
  // Tenants page
  "Platforma kayıtlı tüm tenant firmaları. Pasifleştirilen firmaların kullanıcıları giriş yapamaz.": "All tenant companies on the platform. Users of deactivated companies cannot sign in.",
  "Henüz kayıtlı firma yok. /register-company sayfasından ilk firmayı oluşturabilirsiniz.": "No companies yet. Create the first one at /register-company.",
  // Profile
  "Hesap bilgilerinizi ve şifrenizi güncelleyin.": "Update your account details and password.",
  "Hesap Bilgileri": "Account Details",
  "E-posta adresinizi buradan güncelleyebilirsiniz.": "You can update your email address here.",
  "Şifre Değiştir": "Change Password", "Mevcut Şifre": "Current Password",
  "Yeni Şifre": "New Password", "Yeni Şifre (Tekrar)": "New Password (Repeat)",
  "Şifreyi Güncelle": "Update Password",
  // Backup page
  "Verilerinizi düzenli olarak yedekleyin.": "Back up your data regularly.",
  "PDF Arşivi (ZIP)": "PDF Archive (ZIP)",
  "Tüm modüllerin nizami PDF raporlarını ZIP olarak indirin.": "Download well-formatted PDF reports of all modules as a ZIP.",
  "ZIP İndir": "Download ZIP", "Tam Veri Yedeği (JSON)": "Full Data Backup (JSON)",
  "Tüm kayıtlarınızı geri yükleme formatında indirin.": "Download all your records in restorable format.",
  "JSON İndir": "Download JSON", "E-posta ile Gönder": "Send via Email",
  "Yedek ZIP'ini indirebileceğiniz güvenli bir bağlantı e-posta adresinize gönderilir (24 saat geçerli).": "A secure link to download the backup ZIP will be emailed to you (valid 24 hours).",
  "Yedekten Geri Yükle": "Restore from Backup",
  "Daha önce indirdiğiniz JSON yedeğini yükleyin. Mevcut kayıtlarınızın üzerine yazılır.": "Upload a previously downloaded JSON backup. Your current records will be overwritten.",
  "Dosya Seç ve Geri Yükle": "Choose File & Restore",
  "Geri yüklemek istediğinize emin misiniz?": "Are you sure you want to restore?",
  "Mevcut tüm kayıtlarınız silinip yedekteki kayıtlarla değiştirilecek. Bu işlem geri alınamaz.": "All current records will be deleted and replaced with the backup. This cannot be undone.",
  "Geri Yükle": "Restore", "Haftalık hatırlatma": "Weekly reminder",
  "Her hafta yedekleme hatırlatması e-posta adresinize otomatik gönderilir.": "A backup reminder is automatically emailed to you every week.",
  "Bankaya Ver": "Give to Bank", "Ciro Et": "Endorse", "çek aktarıldı": "checks transferred",
  "Yaklaşan Ödemeler": "Upcoming Payments", "Yaklaşan Tahsilatlar": "Upcoming Collections",
  "Yaklaşan ödeme yok": "No upcoming payments", "Yaklaşan tahsilat yok": "No upcoming collections",
  "ilk kaydı ekleyin": "add the first record", "ZIP indirildi": "ZIP downloaded",
  "JSON indirildi": "JSON downloaded", "Yedek dosyanız hazır": "Your backup is ready",
  "CSV indirildi": "CSV downloaded", "PDF indirildi": "PDF downloaded", "Tümünü seç": "Select all",
  "adresine bir doğrulama bağlantısı gönderdik. E-postanızı doğruladıktan sonra firmanız aktif olur ve giriş yapabilirsiniz.": "— we sent a verification link to this address. Once verified, your company becomes active and you can sign in.",
  "E-posta gönderilemedi.": "Email could not be sent.", "Buradan yeniden gönderin": "Resend from here",
  "Ortalama Vade": "Average Due Date", "gün": "days", "Bankaya Aktar": "Transfer to Bank",
  "Verilen Banka": "Bank Given To", "Verilen Firma": "Company Given To", "Aktar": "Transfer",
  "çek": "check(s)", "Tüm Kategoriler": "All Categories", "Elektrik": "Electricity",
  "Su": "Water", "İnternet": "Internet", "Telefon": "Phone", "Doğalgaz": "Natural Gas",
  "Ödenmedi": "Unpaid", "Kategori": "Category", "Veriliş Tarihi": "Transfer Date",
  "Bankaya Veriliş Tarihi": "Date Given to Bank", "Ciro Tarihi": "Endorsement Date",
  "Aktarım Tarihi": "Transfer Date", "Tarih filtresi": "Date filter",
  "Keşideci": "Drawer", "Lehtar (Cirolayan)": "Payee (Endorser)",
  // Password reset
  "Şifremi unuttum": "Forgot password",
  "E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.": "Enter your email and we'll send you a password reset link.",
  "Sıfırlama Bağlantısı Gönder": "Send Reset Link",
  "Bağlantı gönderildi": "Link sent",
  "Bu e-posta kayıtlıysa şifre sıfırlama bağlantısı gönderildi. E-posta kutunuzu (ve spam klasörünü) kontrol edin. Bağlantı 1 saat geçerlidir.": "If this email is registered, a password reset link has been sent. Check your inbox (and spam folder). The link is valid for 1 hour.",
  "Yeni şifrenizi belirleyin": "Set your new password",
  "En az 8 karakterli yeni bir şifre girin.": "Enter a new password of at least 8 characters.",
  "Şifreler eşleşmiyor": "Passwords do not match",
  "Şifremi Sıfırla": "Reset My Password",
  "Şifreniz güncellendi": "Password updated",
  "Yeni şifrenizle giriş yapabilirsiniz.": "You can now sign in with your new password.",
  "Geçersiz bağlantı": "Invalid link",
  "Şifre sıfırlama bağlantısı geçersiz. Yeni bir bağlantı isteyin.": "The password reset link is invalid. Please request a new one.",
  "Yeni bağlantı isteyin": "Request a new link",
  // User invite & misc new
  "Geri Al": "Take Back",
  "Çek, Alınan Çekler sayfasına geri aktarılacak.": "The check will be transferred back to Received Checks.",
  "çek geri alındı": "check(s) taken back",
  "Excel olarak indir": "Download as Excel",
  "Excel indirildi": "Excel downloaded",
  "Excel ile İçe Aktar": "Import via Excel",
  "Excel Dosyası": "Excel File",
  "Bugün": "Today",
  "Seçilen günün ödemeleri ve tahsilatları listelenir.": "Payments and collections for the selected day are listed.",
  "Tarih aralığı": "Date range",
  "Seçilen tarih aralığındaki ödemeler ve tahsilatlar listelenir.": "Payments and collections in the selected date range are listed.",
  "Kullanıcı Davet Et": "Invite User",
  "Davet Gönder": "Send Invitation",
  "Davet gönderildi": "Invitation sent",
  "Davet yeniden gönderildi": "Invitation resent",
  "Davet iptal edildi": "Invitation cancelled",
  "Kullanıcılarınızı e-posta ile davet edin. Davet bağlantısı 72 saat geçerlidir.": "Invite your users via email. The invitation link is valid for 72 hours.",
  "Bekleyen Davetler": "Pending Invitations",
  "Yeniden Gönder": "Resend",
  "İptal Et": "Cancel",
  "Daveti Kabul Et": "Accept Invitation",
  "Firma hesabına katılmak için adını ve şifreni belirle.": "Set your name and password to join the company account.",
  "Hesabı Oluştur": "Create Account",
  "Hesabınız oluşturuldu. Hoş geldiniz!": "Your account has been created. Welcome!",
  "Geçersiz davet": "Invalid invitation",
  "Davet bağlantısı geçersiz veya süresi dolmuş.": "The invitation link is invalid or expired.",
  "Doğrulama bağlantısı yeni e-posta adresinize gönderildi. Adres doğrulanana kadar mevcut e-postanızla giriş yapmaya devam edebilirsiniz.": "A verification link has been sent to your new email address. You can keep signing in with your current email until it is verified.",
  "Doğrulama bekleniyor:": "Verification pending:",
  // Currency & transfer
  "Para Birimi": "Currency",
  "Tahmini Tahsil Tarihi": "Expected Collection Date",
  "Tahmini Tahsil": "Expected Collection",
  "TCMB Kurları": "CBRT Rates",
  "TCMB Efektif Satış": "CBRT Exchange Rates",
  "Alış": "Buy",
  "Satış": "Sell",
  "Kaynak: Türkiye Cumhuriyet Merkez Bankası · Her iş günü 15:30'da güncellenir": "Source: Central Bank of the Republic of Türkiye · Updated every business day at 3:30 PM",
  // Landing page
  "Ürün": "Product", "Özellikler": "Features", "Nasıl Çalışır?": "How It Works",
  "Hakkımızda": "About Us", "İletişim": "Contact", "Menü": "Menu", "Yasal": "Legal",
  "Yakında": "Coming soon", "Ana Sayfa": "Home",
  "Finans Yönetim Platformu": "Financial Management Platform",
  "Paranızın bugününü görün,": "See your money today,", "yarınını planlayın.": "plan for tomorrow.",
  "TEMHA, işletmenizin günlük ve gelecekteki para akışını daha kolay takip etmenizi sağlayan finans yönetim platformudur.": "TEMHA is the financial management platform that helps your business track its daily and future cash flow more easily.",
  "Çeklerinizi, ödemelerinizi, tahsilatlarınızı, kasanızı, kredi kartlarınızı, POS hareketlerinizi, DBS işlemlerinizi ve aboneliklerinizi tek merkezden yönetin.": "Manage your checks, payments, collections, cash register, credit cards, POS transactions, direct debits and subscriptions from a single hub.",
  "Ürünü Keşfet": "Explore the Product", "Ürünü İncele": "View the Product",
  "Tek Merkez": "Single Hub",
  "Finansal hareketlerinizi farklı tablolar ve araçlar arasında dağılmadan tek platformda takip edin.": "Track your financial movements on a single platform instead of scattered spreadsheets and tools.",
  "Bugünü Görün": "See Today",
  "Kasadan POS'a, çeklerden tahsilatlara kadar günlük para hareketlerinizi daha kolay takip edin.": "Track your daily money movements more easily — from cash register to POS, checks to collections.",
  "Yarını Planlayın": "Plan Tomorrow",
  "Önünüzdeki ödeme ve tahsilatları görünür hale getirerek nakit akışınızı daha kolay planlayın.": "Plan your cash flow more easily by making upcoming payments and collections visible.",
  "Finansal hareketlerinizi tek yerde yönetin.": "Manage your financial movements in one place.",
  "TEMHA, işletmenizin günlük para giriş ve çıkışlarını takip etmenizi kolaylaştıran araçları tek bir platformda bir araya getirir.": "TEMHA brings together the tools that make it easy to track your business's daily money inflows and outflows on a single platform.",
  "Para girişlerinizi takip edin.": "Track your money inflows.",
  "İşletmenize gelecek para hareketlerini tek merkezden takip edin.": "Track money coming into your business from a single hub.",
  "Ödemelerinizi önceden görün.": "See your payments in advance.",
  "Planlanan ve gerçekleşen ödemelerinizi düzenli şekilde takip edin.": "Track planned and completed payments in an organized way.",
  "Mevcut para durumunuzu takip edin.": "Track your current cash position.",
  "Finansal hareketlerinizi merkezi bir görünüm üzerinden takip edin.": "Track your financial movements from a central view.",
  "Çeklerinizi düzenli şekilde yönetin.": "Manage your checks in an organized way.",
  "Çek hareketlerinizi ayrı ayrı takip etmek yerine TEMHA üzerinden merkezi olarak yönetin.": "Manage your check movements centrally on TEMHA instead of tracking them separately.",
  "Yönetim ve Veri": "Administration & Data",
  "Kullanıcı erişimlerini ve veri yönetimini merkezi olarak kontrol edin.": "Centrally control user access and data management.",
  "Ödemelerinizi ve tahsilatlarınızı aynı sistemde takip edin.": "Track your payments and collections in the same system.",
  "Çek hareketlerinizi kontrol altında tutun.": "Keep your check movements under control.",
  "Kasa, POS ve kart hareketlerinizi görün.": "See your cash register, POS and card movements.",
  "Finansal görünümünüzü tek panelden takip edin.": "Track your financial overview from a single dashboard.",
  "Planlanan ve gerçekleşen ödemelerinizi ve tahsilatlarınızı tek platformda düzenli şekilde takip edin.": "Track your planned and completed payments and collections in an organized way on a single platform.",
  "Alınan, bankaya verilen, cirolanan ve kendi çeklerinizi merkezi olarak yönetin.": "Centrally manage received checks, checks given to the bank, endorsed checks and your own checks.",
  "Nakit giriş-çıkışlarınızı, POS günsonu hareketlerinizi ve kart ekstrelerinizi tek yerden takip edin.": "Track your cash inflows and outflows, POS day-end transactions and card statements from one place.",
  "Yaklaşan ödemelerinizi, tahsilatlarınızı ve güncel TCMB kurlarını tek panelde görün.": "See your upcoming payments, collections and current CBRT exchange rates on a single dashboard.",
  "Bugün ne kadar para girdi, ne kadar çıktı?": "How much money came in and went out today?",
  "TEMHA, işletmenizin günlük finansal hareketlerini tek bir yerde takip etmenize yardımcı olur.": "TEMHA helps you track your business's daily financial movements in one place.",
  "PARA GİRİŞLERİ": "MONEY IN", "PARA ÇIKIŞLARI": "MONEY OUT",
  "KASA / FİNANSAL GÖRÜNÜM": "CASH REGISTER / FINANCIAL OVERVIEW",
  "Tüm hareketler tek merkezde birleşir.": "All movements come together in one hub.",
  "Tahsilatlar": "Collections", "Çekler": "Checks", "Ödemeler": "Payments",
  "Yarın ne olacak?": "What will happen tomorrow?",
  "Yaklaşan ödeme ve tahsilatlarınızı daha düzenli takip ederek finansal planlamanızı kolaylaştırın.": "Simplify your financial planning by tracking your upcoming payments and collections more consistently.",
  "Kayıtlarınızı yönetin": "Manage your records",
  "Finansal hareketlerinizi TEMHA'da düzenli şekilde kaydedin.": "Record your financial movements in TEMHA consistently.",
  "Para akışınızı takip edin": "Track your money flow",
  "Ödemeleri, tahsilatları, çekleri, kasa, POS ve kart hareketlerini tek yerden takip edin.": "Track payments, collections, checks, cash register, POS and card movements from one place.",
  "Yaklaşan finansal hareketlerinizi görünür hale getirerek nakit akışınızı daha kolay planlayın.": "Plan your cash flow more easily by making upcoming financial movements visible.",
  "Finans yönetimini daha anlaşılır hale getirin.": "Make financial management easier to understand.",
  "Tek Platform": "Single Platform",
  "Finansal hareketlerinizi tek yerde takip edin.": "Track your financial movements in one place.",
  "Görünürlük": "Visibility",
  "Günlük ve yaklaşan para hareketlerinizi daha kolay görün.": "See your daily and upcoming money movements more easily.",
  "Kontrol": "Control",
  "Ödeme ve tahsilat süreçlerinizi düzenli şekilde yönetin.": "Manage your payment and collection processes in an organized way.",
  "Sadelik": "Simplicity",
  "Finansal hareketlerinizi karmaşık tablolar yerine anlaşılır bir arayüzde takip edin.": "Track your financial movements in a clear interface instead of complex spreadsheets.",
  "Finansal hareketlerinizi tek yerde görmek ister misiniz?": "Want to see your financial movements in one place?",
  "TEMHA ile işletmenizin günlük ve gelecekteki para akışını daha kolay takip edin.": "Track your business's daily and future cash flow more easily with TEMHA.",
  "Firmanızı TEMHA ile yönetmeye başlayın.": "Start managing your company with TEMHA.",
  "Firma Kaydı Oluştur": "Create Company Account",
  "İşletmelerin günlük ve gelecekteki para akışını daha kolay takip etmesini sağlayan finans yönetim platformu.": "The financial management platform that helps businesses track their daily and future cash flow more easily.",
  "Gizlilik": "Privacy", "Kullanım Koşulları": "Terms of Use",
  "Tanıtım verisi — gerçek firma verisi değildir": "Demo data — not real company data",
  "İletişim kanallarımız çok yakında burada yer alacak.": "Our contact channels will be listed here soon.",
  "Krediler": "Loans", "Kredi": "Loan", "Kredi Türü": "Loan Type", "Oran %": "Rate %", "Oran (%)": "Rate (%)",
  "Banka kredileri — vade tarihine göre Yaklaşan Ödemeler'de görünür": "Bank loans — shown in Upcoming Payments by due date",
  "Banka veya kredi türü ara...": "Search bank or loan type...",
  "Kolonlar": "Columns", "Sayfa başına:": "Per page:", "Önceki": "Previous", "İleri": "Next",
  "Ara...": "Search...", "Firma, çek no, açıklama ara...": "Search company, check no, description...",
  "En az 2 karakter yazın": "Type at least 2 characters", "Sonuç bulunamadı": "No results found",
  "Bildirimler": "Notifications", "Bildirim yok.": "No notifications.", "Tümünü Gör": "View All",
  "Bağlı": "Connected", "Çevrimdışı": "Offline",
  "Haftalık Nakit Akışı": "Weekly Cash Flow", "7 günlük ödeme/tahsilat dağılımı": "7-day payment/collection distribution",
  "Bu Hafta": "This Week", "Bu Ay": "This Month", "PDF Rapor": "PDF Report",
  "Toplam Ödeme": "Total Payments", "Toplam Tahsilat": "Total Collections", "Net Akış": "Net Flow",
  "Önceki hafta": "Previous week", "Sonraki hafta": "Next week",
  "Son güncelleme": "Last updated", "Otomatik yenileme: 60sn": "Auto-refresh: 60s",
  "Profil": "Profile", "Finans/Vergi": "Finance/Tax", "Marka": "Brand", "Sistem": "System",
  "Firma Finans Ayarları": "Company Finance Settings", "Varsayılan Para Birimi": "Default Currency",
  "Varsayılan KDV (%)": "Default VAT (%)", "Varsayılan Vade (gün)": "Default Term (days)",
  "Mali Yıl Başlangıcı": "Fiscal Year Start", "Ayarlar kaydedildi": "Settings saved",
  "Firma Logosu": "Company Logo", "Logo Yükle": "Upload Logo", "Logo yüklendi": "Logo uploaded", "Yükle": "Upload",
  "PNG, JPG veya WebP — en fazla 2 MB": "PNG, JPG or WebP — max 2 MB",
  "Logo, dışa aktarılan PDF çıktılarında kullanılır.": "The logo is used in exported PDF documents.",
  "Henüz logo yüklenmedi": "No logo uploaded yet",
  "Uygulama": "Application", "Sürüm": "Version", "Bağlantı": "Connection",
  "Kredi Türü (örn. Rotatif, Taksitli)": "Loan Type (e.g. Revolving, Installment)",
  "Hesap, firma ve marka ayarlarınızı yönetin.": "Manage your account, company and brand settings.",
  "Tahsilatlar": "Collections",
};

const LanguageContext = createContext(null);

function safeGetLang() {
  try {
    return window.localStorage.getItem("temha-lang") || "tr";
  } catch {
    return "tr";
  }
}

function safeSetLang(l) {
  try {
    window.localStorage.setItem("temha-lang", l);
  } catch {
    // iframe/sandbox gibi depolama erişiminin engellendiği ortamlarda sessizce geç
  }
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(safeGetLang);

  const setLang = useCallback((l) => {
    safeSetLang(l);
    setLangState(l);
    document.documentElement.lang = l;
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (s) => (lang === "en" && typeof s === "string" ? EN[s] ?? s : s),
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
